export default __webpack_public_path__ + "static/media/logo_horizontal_esteso.38d814ee.png";